import { css } from '../themed-styled-components';
import * as map from 'lodash.mapvalues';

type BreakPoints<T = string> = {
  desktop: T;
  tablet: T;
  tabletBig: T;
  mobile: T;
  mobileBig: T;
};

export const BREAK_POINTS_DIMENSIONS_VALUES_IN_PX: BreakPoints<number> = {
  desktop: 1024,
  tabletBig: 900,
  tablet: 768,
  mobileBig: 481,
  mobile: 0,
};

const BREAK_POINTS: BreakPoints = map(BREAK_POINTS_DIMENSIONS_VALUES_IN_PX, (_) => `(min-width: ${_}px)`);

export default BREAK_POINTS;



// WEBPACK FOOTER //
// ./packages/platform-common-ui/styling/media-queries.ts